export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10662.261b7cd9.jpg";